import React from 'react';
import PropTypes from 'prop-types';
import { Button} from 'reactstrap';
import {apiRequest, apiPost} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import Select from 'react-select';
import {PickupStatus} from '../Runs/PickupStatus';

class RunPickupEditView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isEditView: false,
      pickups: [],
      originalPickups: [],
      runId: props.runId, 
      pickupStatus: [{value:'PEN', label:'Pending'},
                    {value:'COM', label:'Completed'},
                    {value:'CREQ', label:'Confirmation Requested'},
                    {value:'CAN', label:'Cancelled'}], 
    };

    this.loadRunPickups = this.loadRunPickups.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.saveRun = this.saveRun.bind(this);
    this.resetRun = this.resetRun.bind(this);
    this.cancel = this.cancel.bind(this);
    this.enterEditMode = this.enterEditMode.bind(this);
  }

  async loadRunPickups(runId) {
    this.setState({pickups: [],originalPickups: [], runId});
    await apiRequest(`/api/pickups?runId=${runId}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching pickups, error: ${x.error ? x.error : x.data.Message}`);
          this.setState({pickups: [],originalPickups: [], isEditView: false});
        } else {
          this.setState({pickups: Array.from(x.data), originalPickups: Array.from(x.data)});
        }
      });
  }

  handleStatusChange(pickup, input) {
    let {pickups} = this.state;
    let statePickup = {..._.find(pickups, x => x.id == pickup.id), pickupStatusUniqueCode: input};
    this.setState({
      pickups: pickups.map(x => {
        return x.id == statePickup.id ? statePickup : x;
      })
    });
  }

  async saveRun() {
    let {runId, pickups} = this.state;
    await apiPost(`/api/pickups?runId=${runId}`, pickups)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving pickups, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          toastr.success('Saved pickups');
          this.setState({pickups: Array.from(x.data), originalPickups: Array.from(x.data)});
          apiRequest(`/api/runs/${runId}?includeDriverLocations=false`)
            .then(y => {
              if (y.error || y.data.Message) {
                toastr.error(`Error while fetching runId: ${runId} error: ${y.error ? y.error : y.data.Message}`);
              } else {
                this.props.onFinishEditPickups({...y.data});
                this.setState({isEditView: false});
              }
            });
        }
      });
  }

  resetRun(){
    this.setState({pickups: [...this.state.originalPickups]});
  }

  cancel(){
    this.resetRun();
    this.setState({isEditView: false});
    this.props.onLeaveEditPickups();
  }

  enterEditMode(){
    this.setState({isEditView: true});
    this.props.onEnterEditPickups();
  }

  componentDidMount(){
    if(this.state.runId > 0){
      this.loadRunPickups(this.state.runId).then(() => {});
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.runId !== prevProps.runId){
      this.loadRunPickups(this.props.runId).then(() => {});
    }
    
  }

  render(){
    return (
      this.state.isEditView ? (
      <div>
      <div style={{marginBottom: '10px' }}>
        <Button color="primary" onClick={this.saveRun}><i className="fa fa-save" />&nbsp;&nbsp;Save pickups</Button>&nbsp;
        <Button color="secondary" onClick={this.resetRun}><i className="fa fa-undo" /></Button>&nbsp;
        <Button color="secondary" onClick={this.cancel}><i className="fa fa-mail-reply" /></Button>&nbsp;
      </div>
      <div style={{minHeight:'250px', maxHeight: '450px', overflow:'auto', paddingRight: '50px'}}>
        {this.state.pickups.map(x => {
          let status = PickupStatus({pickupStatusCode: x.pickupStatusUniqueCode, isUrgentJob: x.isUrgentJob, isUrgentDelivery: x.isUrgentDelivery, isUrgentCollection: x.isUrgentCollection}, this.props.truckCollectionTypeCode);
          return (<div
            className={`list-group-item list-group-item-${status.colour}`}
            key={x.id}>
            <i className={status.icon}/>
            <span style={{marginLeft: '10px'}}>{x.locationName}&nbsp;&nbsp;</span>
            {x.pickupNote && x.pickupNote != '' && <span style={{marginLeft: '10px'}}><b>Notes:</b> {x.pickupNote}</span>}
            {x.cancelReason && x.cancelReason != '' && <span style={{marginLeft: '10px'}}><b>Notes:</b> {x.cancelReason}</span>}
            <span style={{
              marginLeft: 'auto',
              width: '175px'}}
                  className="pull-right"
            >
            <Select
              name="pickupStatus"
              value={x.pickupStatusUniqueCode}
              multi={false}
              simpleValue={true}
              clearable={false}
              options={this.state.pickupStatus}
              onChange={(e) => this.handleStatusChange(x, e)}
            />
              </span>
          </div>);
        })}
      </div>
    </div>) :
      (<Button style={this.props.style} color="primary" onClick={this.enterEditMode}>Edit Pickups</Button>));
  }
}

RunPickupEditView.propTypes = {
  runId: PropTypes.number.isRequired,
  onFinishEditPickups: PropTypes.func.isRequired,
  onEnterEditPickups: PropTypes.func.isRequired,
  onLeaveEditPickups: PropTypes.func.isRequired
};

export default RunPickupEditView;